import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateSectionTotal } from '../../redux/app-reducer'
import { getSectionTotalKey } from '../sections/section'
import LabeledRowOutput from './LabeledRowOutput'

/**
 * This smart component tracks 0-n values in the redux store by "form key".
 * The idea is that this component watches the store for changes to those
 * specific number values and sums them up to then render a total for the
 * user to see e.g. see the value 100 as composed of three different input
 * boxes with the values 25, 25, and 50.
 * This component will also store that total (100 in the example above)
 * back into the redux store using the sectionNumber prop to differentiate its
 * total from other totals
 */
export class FormNumberTotal extends Component {
  /**
   * Handle React event
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    let total = 0

    nextProps.formVals.forEach(cur => {
      total += +cur
    })
    if (total !== nextProps.total) {
      this.props.dispatch(updateSectionTotal(total, this.props.sectionNumber))
    }
  }

  /**
   * Render component
   * @returns {XML}
   */
  render () {
    // this is really just a fail-safe for testing the raw component
    // the dispatch in the c'tor *should* always set this to zero if
    // we don't have a total
    let total = this.props.total ? this.props.total : 0
    return <LabeledRowOutput label='Total' output={total} />
  }
}

FormNumberTotal.propTypes = {
  formKeys: PropTypes.array.isRequired,
  sectionNumber: PropTypes.number.isRequired
}

export function mapStateToProps (state, ownProps) {
  let formVals = []
  ownProps.formKeys.forEach(formKey => {
    if (state.get('forms').get(formKey)) {
      formVals.push(state.get('forms').get(formKey))
    }
  })
  return {
    formVals,
    total: state.get('app').get(getSectionTotalKey(ownProps.sectionNumber))
  }
}

export default connect(mapStateToProps)(FormNumberTotal)



// WEBPACK FOOTER //
// ./src/components/forms/FormNumberTotal.js